/* TenzBuild Tech — theme scripts (no dependencies) */
(function () {
  'use strict';

  document.documentElement.classList.add('js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  /* ---------- Mobile menu ---------- */
  var menuBtn = $('[data-menu-toggle]');
  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      var nav = document.getElementById('MobileNav');
      var open = nav.hasAttribute('hidden');
      nav.toggleAttribute('hidden', !open);
      menuBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---------- Toast ---------- */
  var toast = $('#CartToast'), toastTimer;
  function showToast(text, isError) {
    if (!toast) return;
    $('.toast__text', toast).textContent = text;
    toast.classList.toggle('is-error', !!isError);
    $('.toast__link', toast).style.display = isError ? 'none' : '';
    toast.removeAttribute('hidden');
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        showToast((res.data.product_title || 'Item') + ' added to cart');
        return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
      .catch(function (err) { showToast(err.message, true); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: auto-update on quantity change */
  var submitCart = debounce(function (form) { form.submit(); }, 600);
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit-cart]')) submitCart(e.target.form);
  });

  /* ---------- Collection filters ---------- */
  var filterForm = $('[data-filters]');
  if (filterForm) {
    var applyFilters = function () {
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    };
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-autosubmit]')) applyFilters();
    });
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(); });
    var ft = $('[data-filter-toggle]', filterForm), facets = $('[data-facets]', filterForm);
    if (ft && facets) ft.addEventListener('click', function () {
      var open = facets.classList.toggle('is-open');
      ft.setAttribute('aria-expanded', String(open));
    });
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.addEventListener('click', function (e) {
        $$('.facet[open]', filterForm).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    }
  }

  /* ---------- Product: variant picker + gallery ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root);
    var priceWrap = $('[data-price-wrap]', root);
    var stock = $('[data-stock]', root);
    var sku = $('[data-sku]', root);
    var fieldsets = $$('fieldset[data-option-index]', root);

    function showMedia(id) {
      if (!id) return;
      $$('.gallery__slide', root).forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId == id); });
      $$('.gallery__thumb', root).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
    }

    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }

    function markAvailability(sel) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var test = sel.slice(); test[i] = input.value;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return o === test[j]; });
          });
          input.closest('.pill').classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) { var span = $('[data-option-value]', fs); if (span) span.textContent = sel[i]; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      markAvailability(sel);

      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';

      var html = '<div class="tag' + (v.compare ? ' is-sale' : '') + '" data-price><span class="tag__price">' + v.price + '</span>';
      if (v.compare) html += '<s class="tag__was">' + v.compare + '</s>';
      priceWrap.innerHTML = html + '</div>';

      if (stock) {
        var msg;
        if (!v.available) msg = '<span class="stock__dot stock__dot--out"></span> Out of stock';
        else if (v.qty !== null && v.qty > 0 && v.qty <= 5) msg = '<span class="stock__dot stock__dot--in"></span> Only ' + v.qty + ' left in stock';
        else msg = '<span class="stock__dot stock__dot--in"></span> In stock, ready to ship';
        stock.innerHTML = msg;
      }
      if (sku) sku.textContent = v.sku ? 'SKU: ' + v.sku : '';
      showMedia(v.media);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var load = function () {
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- Login: show password recovery ---------- */
  var showRecover = $('[data-show-recover]');
  if (showRecover) showRecover.addEventListener('click', function (e) {
    e.preventDefault();
    var r = $('[data-recover]'); r.classList.add('is-open'); r.scrollIntoView({ behavior: 'smooth' });
  });
  if (window.location.hash === '#recover' && $('[data-recover]')) $('[data-recover]').classList.add('is-open');

  /* ==========================================================================
     Motion: the hero scene turns toward the pointer (or with scroll on touch).
     This is the page's only ambient motion, alongside the swinging price tag.
     ========================================================================== */
  if (!reduceMotion) {
    $$('[data-hero]').forEach(function (hero) {
      var target = $('[data-parallax]', hero);
      if (!target) return;
      if (finePointer) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          target.style.setProperty('--ry', (x * 22).toFixed(2));
          target.style.setProperty('--rx', (-y * 12).toFixed(2));
        });
        hero.addEventListener('pointerleave', function () {
          target.style.setProperty('--ry', 0); target.style.setProperty('--rx', 0);
        });
      } else {
        window.addEventListener('scroll', function () {
          var p = Math.min(window.scrollY / 500, 1);
          target.style.setProperty('--ry', (p * 16).toFixed(2));
          target.style.setProperty('--rx', (p * -6).toFixed(2));
        }, { passive: true });
      }
    });
  }
})();
